var _style, _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollarCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-179 55.7 40.3 40.3",
    style: {
      enableBackground: "new -179 55.7 40.3 40.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2E2E2E;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "savings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-157.8,74.5v-6.9c2.4,0.3,3.2,1.6,3.3,1.7c0.3,0.5,0.9,0.6,1.4,0.4c0.5-0.3,0.6-0.9,0.4-1.4 c-0.1-0.1-1.4-2.4-5-2.7v-1.7c0-0.6-0.4-1-1-1s-1,0.4-1,1v1.7c-3.5,0.4-5.1,2.7-5.1,4.9c0,3.5,2.7,4.7,5.1,5.5v8.2 c-3.2-0.4-3.8-2.2-3.8-2.3c-0.1-0.5-0.7-0.9-1.2-0.7c-0.5,0.1-0.9,0.7-0.7,1.2c0,0.1,0.9,3.3,5.8,3.8v1.7c0,0.6,0.4,1,1,1 s1-0.4,1-1v-1.7c3.3-0.3,5.8-2.5,5.8-5.3C-152,76.6-155.1,75.3-157.8,74.5z M-159.8,73.8c-2-0.7-3.1-1.5-3.1-3.4 c0-1.5,1.2-2.6,3.1-2.9V73.8z M-157.8,84.2v-7.6c2.4,0.8,3.8,1.7,3.8,4.3C-154,82.7-155.9,83.9-157.8,84.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-158.8,55.8c-11,0-20,9-20,20c0,11,9,20,20,20s20-9,20-20C-138.8,64.8-147.8,55.8-158.8,55.8z M-158.8,94.8 c-10.5,0-19-8.5-19-19c0-10.5,8.5-19,19-19s19,8.5,19,19C-139.8,86.3-148.3,94.8-158.8,94.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarCircle);
export default __webpack_public_path__ + "static/media/dollar-circle.678568f93b983d994d76c43ab1b26075.svg";
export { ForwardRef as ReactComponent };